// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.addprojet-menus-zoom-fix .MuiPopover-root,
body.addprojet-menus-zoom-fix .MuiMenu-root,
body.addprojet-menus-zoom-fix .MuiModal-root {
  /* Override the global zoom compensation used elsewhere in the app.
     This page-scoped rule keeps MUI Select/menus aligned with their anchors. */
  zoom: 1 !important;
}

body.addprojet-menus-zoom-fix .MuiPopover-paper,
body.addprojet-menus-zoom-fix .MuiMenu-paper {
  zoom: 1 !important;
}

`, "",{"version":3,"sources":["webpack://./src/views/projets/addprojet-menu-fix.css"],"names":[],"mappings":"AAAA;;;EAGE;+EAC6E;EAC7E,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB","sourcesContent":["body.addprojet-menus-zoom-fix .MuiPopover-root,\nbody.addprojet-menus-zoom-fix .MuiMenu-root,\nbody.addprojet-menus-zoom-fix .MuiModal-root {\n  /* Override the global zoom compensation used elsewhere in the app.\n     This page-scoped rule keeps MUI Select/menus aligned with their anchors. */\n  zoom: 1 !important;\n}\n\nbody.addprojet-menus-zoom-fix .MuiPopover-paper,\nbody.addprojet-menus-zoom-fix .MuiMenu-paper {\n  zoom: 1 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
